import styled from "styled-components";
export const Styles = styled.div`
  #imagesGallerySection {
    margin-top: 120px;
    position: relative;
    margin-bottom: 200px;
  }
  #imagesGallerySection .react-img {
    position: absolute;
    height: 50%;
    top: -80px;
    right: -160px;
    transform: rotate(210deg);
  }
  #imagesGallerySection .container {
    position: relative;
  }
  #imagesGallerySection .container .tag1 {
    position: absolute;
    left: 0;
    top: -50px;
    height: 30%;
  }
  #imagesGallerySection .container .tag2 {
    position: absolute;
    left: 50px;
    bottom: -150px;
    height: 20%;
    transform: rotate(-20deg);
  }
  #imagesGallerySection .container .semi-column {
    position: absolute;
    right: 0;
    height: 40%;
    bottom: -150px;
  }
  #imagesGallerySection .main-img {
    height: 600px;
    border-radius: 25px;
    overflow: hidden;
  }
  #imagesGallerySection .main-img img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  #imagesGallerySection .section-data {
    display: flex;
    flex-direction: column;
    height: 600px;
  }
  #imagesGallerySection .section-info .title {
    font-size: 35px;
    color: var(--dark-purple);
    display: block;
    margin-bottom: 25px;
  }
  #imagesGallerySection .section-info .description {
    font-size: 25px;
    color: var(--dark-color) !important;
    margin-bottom: 40px;
  }
  #imagesGallerySection .section-data .img-container {
    height: 200px;
    border-radius: 25px;
    overflow: hidden;
  }
  #imagesGallerySection .section-data .img-container img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  @media (max-width: 1080px) {
    #imagesGallerySection{
      margin-bottom:140px;
    }
    #imagesGallerySection .react-img {
      height: 13%;
    }
    #imagesGallerySection .container .tag1 {
      left: -100px;
      height: 10%;
    }
    #imagesGallerySection .container .tag2 {
      left: 20px;
      top: 100%;
      height: 5%;
    }
    #imagesGallerySection .container .semi-column {
      height: 8%;
      top: 98%;
    }
    #imagesGallerySection .section-info {
      margin-bottom: 25px;
    }
    #imagesGallerySection .main-gallery-container {
      text-align: center;
      flex-direction: column;
    }
    #imagesGallerySection .section-data {
      height: 100%;
      margin-top: 20px;
    }
    #imagesGallerySection .section-data .img-container {
      height: 100%;
    }
    #imagesGallerySection .section-data .costomize-col {
      margin-bottom: 20px;
    }
    
  }
  @media (max-width: 767px) {
    #imagesGallerySection{
      margin-bottom:80px;
    }
    #imagesGallerySection .container .tag2 {
      top:99%;
    }
    #imagesGallerySection .container .semi-column {
      height: 6%;
    }
  }
`;
